
























import Vue from 'vue'
import { SelectFormField } from '@/model/registration'
import { PropType } from 'vue/types/umd'

export default Vue.extend({
  name: 'TextInput',
  props: {
    value: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    field: {
      type: Object as PropType<SelectFormField>,
      required: true
    }
  },
  computed: {
    inputId (): string {
      return `select-${this.fieldName}`
    }
  },
  methods: {
    onInput (e: InputEvent) {
      this.$emit('input', { value: (e.target as HTMLInputElement).value })
    }
  }
})
